module.exports = __webpack_public_path__ + "static/media/phoneWithImage.7b1a7e0a.png";